import { nextSlotTime, offseasonAutomation } from '@shared/automation.js';
import { inOffseason } from '@/utils/leagueLabels';

// When a league's next games (or, in the offseason, its next offseason
// step) happen, in the viewer's own time zone: "Today at 8:00 PM",
// "Tomorrow at 1:00 PM", "Fri, Oct 31 at 8:00 PM". null when the league's
// daily games are off.
export function nextGamesText(league, now = new Date()) {
    if (!league?.automation?.enabled) return null;
    // The offseason moves once a day, at the last game time.
    const automation = inOffseason(league.season) ? offseasonAutomation(league.automation) : league.automation;
    const at = nextSlotTime(automation, now);
    if (!at) return null;
    return whenText(at, now);
}

// When game day `day` will be played: the league plays one game day per
// game time, so it's the (day - current day)-th game time from now.
// null when daily games are off.
export function gameDayText(league, day, now = new Date()) {
    if (!league?.automation?.enabled || inOffseason(league.season)) return null;
    const ahead = day - (league.season?.day ?? 0);
    if (ahead < 1 || ahead > 20) return null;
    let at = now;
    for (let i = 0; i < ahead; i++) {
        at = nextSlotTime(league.automation, new Date(at.getTime() + (i ? 60 * 1000 : 0)));
        if (!at) return null;
    }
    return whenText(at, now);
}

export function whenText(at, now = new Date()) {
    const time = at.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
    const day = (d) => d.toDateString();
    const tomorrow = new Date(now.getTime() + 24 * 3600 * 1000);
    if (day(at) === day(now)) return `Today at ${time}`;
    if (day(at) === day(tomorrow)) return `Tomorrow at ${time}`;
    return `${at.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })} at ${time}`;
}

// For use mid-sentence: "tips off today at 8:00 PM".
export function midSentence(text) {
    return text?.replace(/^(Today|Tomorrow)/, w => w.toLowerCase());
}
